import type { DateRange } from 'react-day-picker'

export type TimeRange = '' | 'today' | '7d' | '30d' | '90d' | 'custom'

export const TIME_RANGE_OPTIONS: { value: TimeRange; label: string }[] = [
  { value: '', label: 'All Time' },
  { value: 'today', label: 'Today' },
  { value: '7d', label: '7 Days' },
  { value: '30d', label: '30 Days' },
  { value: '90d', label: '90 Days' },
]

function endOfDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59)
}

export function getDateFilters(
  timeRange: TimeRange,
  dateRange: DateRange | undefined
): { created_after?: string; created_before?: string } {
  if (timeRange === 'custom' && dateRange) {
    return {
      created_after: dateRange.from ? dateRange.from.toISOString() : undefined,
      created_before: dateRange.to
        ? endOfDay(dateRange.to).toISOString()
        : dateRange.from
          ? endOfDay(dateRange.from).toISOString()
          : undefined,
    }
  }

  if (!timeRange || timeRange === 'custom') return {}

  const now = new Date()
  switch (timeRange) {
    case 'today': {
      const start = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      return { created_after: start.toISOString() }
    }
    case '7d': {
      const start = new Date(now)
      start.setDate(start.getDate() - 7)
      return { created_after: start.toISOString() }
    }
    case '30d': {
      const start = new Date(now)
      start.setDate(start.getDate() - 30)
      return { created_after: start.toISOString() }
    }
    case '90d': {
      const start = new Date(now)
      start.setDate(start.getDate() - 90)
      return { created_after: start.toISOString() }
    }
    default:
      return {}
  }
}
